module.exports = __webpack_public_path__ + "static/media/Gia_certi.131b9f1b.jpg";